import React from 'react';

const ViewAllButton: React.FC = () => {
  return (
    <button className="flex gap-1.5 items-center w-full justify-center px-5 py-2.5 text-xl font-bold rounded-2xl border-3 border-yellow-400 border-solid cursor-pointer focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-opacity-50" tabIndex={0}>
      <span className="text-black">View All</span>
    </button>
  );
};

export default ViewAllButton;